import axios from 'axios';
import constantes from "../constantes";
import moment from "moment";
import store from "../store";

const PREFIJO="/api/Ntsrd";
const PREFIJOV2="/api";

export default {
    interesadoV2(formulario,pasos) {
        let accesorios=[];
        let resumen={
            paquetes:[],
            totalpaquetes:0,
            accesorios:[],
            totalAccesorios:0,
            total:0,
        };
        pasos[2].accesorios.individuales.map(function(item){
            if(item.id){
                accesorios.push({ndt1:item.id});
                resumen.accesorios.push({detalle:item.dt7||item.dt2,precio:item.ndt2});
                resumen.totalAccesorios+=item.ndt2;
            }
        });
        pasos[2].accesorios.kit.map(function(item){
            if(item.id){
                accesorios.push({ndt1:item.id});
                resumen.accesorios.push({detalle:item.dt7||item.dt2,precio:item.ndt2});
                resumen.totalAccesorios+=item.ndt2;
            }
        });
        pasos[3].resumen.map(function(item){
            resumen.paquetes.push({detalle:item.dt1,precio:item.ndt1});
            resumen.totalpaquetes+=item.ndt1;
        });
        resumen.total=resumen.totalpaquetes+resumen.totalAccesorios+constantes.funciones.sumar3('ndt3',pasos[2].accesorios.cupones);
        const dto={
            dt1:formulario.nombres,//nombres,
            dt3:formulario.apellidos,//apellidos
            dt5:formulario.telefono,//telefono,
            dt6:formulario.email,//email
            dt7:pasos[1].modelo.id,//formulario modelo
            dt10:formulario.ci,
            dt11:JSON.stringify(JSON.stringify(resumen)),
            dt12:constantes.Constantes.enumeraciones.fuente,
            dt13:constantes.Constantes.enumeraciones.producto,
            dt14:constantes.Constantes.enumeraciones.linea,
            dt15:constantes.Constantes.enumeraciones.dni,
            dt16:process.env.VUE_APP_PAIS_NAME,
            dt17:constantes.Constantes.enumeraciones.natural,
            dt18:process.env.VUE_APP_MARCA,
            dt20:formulario.token,//recaptcha
            dt100:formulario.password,
            ndt1:constantes.Constantes.enumeraciones.idApp,//id aplicacion
            ndt2:store.getters.getCampana || formulario.tipo,//enumeracion
            ndt6:pasos[3].agencia.id,//agencia
            ndt8:pasos[2].color.id,//color
            ndt9:pasos[2].paquete.id,//formulario,//paquete
            ndt10:resumen.total,
            ndt11:pasos[1].modelo.id,//formulario modelo
            // ndt13:formulario.genero? formulario.genero.id:0,
            // ddt1: formulario.fecha? moment(formulario.fecha,"DD/MM/YYYY").toISOString():"",//
            bdt1:formulario.promo,
            elements:accesorios,//lista de accesorios
            elements2:pasos[2].accesorios.individuales,
            elements3:pasos[2].accesorios.kit,
            elements4:pasos[2].accesorios.cupones,
        };
        return axios.post(`${PREFIJOV2}/NtgrNcnlddLds/VmCrNvLds`,dto);
    },
    interesado(formulario,pasos) {
        let accesorios=[];
        let resumen={
            paquetes:[],
            totalpaquetes:0,
            accesorios:[],
            totalAccesorios:0,
            total:0,
        };
        pasos[2].accesorios.individuales.map(function(item){
            if(item.id){
                accesorios.push({ndt1:item.id});
                resumen.accesorios.push({detalle:item.dt7||item.dt2,precio:item.ndt2});
                resumen.totalAccesorios+=item.ndt2;
            }
        });
        pasos[2].accesorios.kit.map(function(item){
            if(item.id){
                accesorios.push({ndt1:item.id});
                resumen.accesorios.push({detalle:item.dt7||item.dt2,precio:item.ndt2});
                resumen.totalAccesorios+=item.ndt2;
            }
        });
        pasos[3].resumen.map(function(item){
            resumen.paquetes.push({detalle:item.dt1,precio:item.ndt1});
            resumen.totalpaquetes+=item.ndt1;
        });
        resumen.total=resumen.totalpaquetes+resumen.totalAccesorios+constantes.funciones.sumar3('ndt3',pasos[2].accesorios.cupones);
        const dto={
            dt1:formulario.nombres,//nombres,
            dt3:formulario.apellidos,//apellidos
            dt5:formulario.telefono,//telefono,
            dt6:formulario.email,//email
            dt7:pasos[1].modelo.id,//formulario modelo
            dt10:formulario.ci,
            dt11:JSON.stringify(JSON.stringify(resumen)),
            dt12:constantes.Constantes.enumeraciones.fuente,
            dt13:constantes.Constantes.enumeraciones.producto,
            dt14:constantes.Constantes.enumeraciones.linea,
            dt15:constantes.Constantes.enumeraciones.dni,
            dt16:process.env.VUE_APP_PAIS_NAME,
            dt17:constantes.Constantes.enumeraciones.natural,
            dt18:process.env.VUE_APP_MARCA,
            dt20:formulario.token,//recaptcha
            dt100:formulario.password,
            ndt1:constantes.Constantes.enumeraciones.idApp,//id aplicacion
            ndt2:store.getters.getCampana || formulario.tipo,//enumeracion
            ndt6:pasos[3].agencia.id,//agencia
            ndt8:pasos[2].color.id,//color
            ndt9:pasos[2].paquete.id,//formulario,//paquete
            ndt10:resumen.total,
            ndt11:pasos[1].modelo.id,//formulario modelo
            // ndt13:formulario.genero? formulario.genero.id:0,
            // ddt1: formulario.fecha? moment(formulario.fecha,"DD/MM/YYYY").toISOString():"",//
            bdt1:formulario.promo,
            elements:accesorios,//lista de accesorios
            elements2:pasos[2].accesorios.individuales,
            elements3:pasos[2].accesorios.kit,
            elements4:pasos[2].accesorios.cupones,
        };
        return axios.post(`${PREFIJO}/VmCrNtr`,dto);
    },
    campana(formulario) {
        const dto={
            dt1:formulario.nombres,//nombres,
            dt3:formulario.apellidos,//apellidos
            dt5:formulario.telefono,//telefono,
            dt6:formulario.email,//email
            dt7:formulario.modelo.id,//formulario,//modelo version
            dt8:formulario.placa ? formulario.placa.toUpperCase() : null,//formulario,//modelo version
            dt9:formulario.direccion,//formulario,//modelo version
            dt10:formulario.ci,
            dt11:formulario.vehiculo ? formulario.vehiculo.toUpperCase() : null,
            dt12:constantes.Constantes.enumeraciones.fuente,
            dt13:constantes.Constantes.enumeraciones.producto,
            dt14:constantes.Constantes.enumeraciones.linea,
            dt15:constantes.Constantes.enumeraciones.dni,
            dt16:process.env.VUE_APP_PAIS_NAME,
            dt18:constantes.Constantes.enumeraciones.texto,
            dt20:formulario.token,//recaptcha
            ndt2:formulario.tipo,//
            ndt11:formulario.modelo.id,//formulario modelo
            bdt1:formulario.promo,
            ddt1:formulario.fecha? moment(formulario.fecha,"DD/MM/YYYY").toISOString():"",//
            // ndt13:formulario.genero? formulario.genero.id:0,
        };
        return axios.post(`${PREFIJO}/VmCrNtr`,dto);
    },
    validacionCI(formulario) {
        const dto={
            dt1:formulario.ci,
            ndt2:formulario.tipo,
        };
        return axios.post(`${PREFIJO}/VmVlInt`,dto);
    }
};
